(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["putty-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(root){
    if(!root || root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    root.querySelectorAll('.pf-q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.pf-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    root.addEventListener('shopify:block:select', function(e){
      var item = e.target.closest ? e.target.closest('.pf-item') : null;
      if(item){ item.classList.add('is-open'); }
    });
  }
  function initAll(){ document.querySelectorAll('.putty-faq').forEach(initFaq); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('.putty-faq');
    if(root){ delete root.dataset.pfReady; initFaq(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["putty-lineup"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCard(card){
    if(card.dataset.plReady) return;
    card.dataset.plReady = '1';
    var panels = card.querySelectorAll('.pl-panel');
    if(!panels.length) return; /* 手動カード */
    var img = card.querySelector('.pl-img');
    var stock = card.querySelector('.pl-stock');
    var cta = card.querySelector('.pl-cta');
    var links = card.querySelectorAll('.pl-link');
    var switches = card.querySelectorAll('.pl-sleeve');
    var active = panels[0];

    function variantsOf(panel){
      var el = panel.querySelector('.pl-variants-data');
      if(!el) return [];
      try { return JSON.parse(el.textContent); } catch(e){ return []; }
    }
    function selectedVariant(panel){
      var sel = {};
      panel.querySelectorAll('.pl-opt-group').forEach(function(g){
        var a = g.querySelector('.pl-opt.is-active') || g.querySelector('.pl-opt');
        if(a){ a.classList.add('is-active'); sel[g.dataset.position] = a.dataset.value; }
      });
      var vs = variantsOf(panel);
      for(var i=0;i<vs.length;i++){
        var v = vs[i], ok = true;
        for(var p=0;p<v.options.length;p++){ if(sel[p+1] !== v.options[p]){ ok=false; break; } }
        if(ok) return v;
      }
      return null;
    }
    function update(){
      var base = active.dataset.productUrl;
      var def = active.dataset.defaultImage;
      var v = selectedVariant(active);
      var url = base, src = def, soldout = false, msg = '';
      if(v){
        url = base + '?variant=' + v.id;
        if(v.image){ src = v.image; }
        soldout = !v.available;
        if(soldout){ msg = '選択中の組み合わせは在庫切れです'; }
      } else {
        soldout = true; msg = 'この組み合わせはご用意がありません';
      }
      links.forEach(function(a){ a.setAttribute('href', url); });
      if(img && src){ img.setAttribute('src', src); }
      if(stock){ stock.textContent = msg; }
      if(cta){ cta.classList.toggle('is-soldout', soldout); }
    }

    card.querySelectorAll('.pl-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var g = btn.closest('.pl-opt-group');
        g.querySelectorAll('.pl-opt').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });
    switches.forEach(function(btn){
      btn.addEventListener('click', function(){
        switches.forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var idx = parseInt(btn.getAttribute('data-target'), 10) || 0;
        panels.forEach(function(p, i){ p.style.display = (i === idx) ? '' : 'none'; });
        active = panels[idx];
        update();
      });
    });
    update();
  }
  function initAll(){ document.querySelectorAll('.putty-lineup .pl-card').forEach(initCard); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('.putty-lineup');
    if(root){ root.querySelectorAll('.pl-card').forEach(function(c){ delete c.dataset.plReady; initCard(c); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["putty-mv"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initMv(root){
    if(!root || root.dataset.mvReady) return;
    root.dataset.mvReady = '1';
    var track = root.querySelector('.putty-mv-track');
    var slides = root.querySelectorAll('.putty-mv-slide');
    if(!track || slides.length < 2) return;
    var dots = root.querySelectorAll('.putty-mv-dot');
    var n = slides.length, i = 0, timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(idx){
      i = (idx + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for(var k=0;k<dots.length;k++){ dots[k].classList.toggle('is-active', k === i); }
    }
    function next(){ go(i + 1); }
    function prev(){ go(i - 1); }
    function start(){ if(autoplay && !reduce){ stop(); timer = setInterval(next, speed); } }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }

    var pv = root.querySelector('.putty-mv-prev');
    var nx = root.querySelector('.putty-mv-next');
    if(pv) pv.addEventListener('click', function(){ prev(); start(); });
    if(nx) nx.addEventListener('click', function(){ next(); start(); });
    for(var k=0;k<dots.length;k++){ (function(idx){ dots[idx].addEventListener('click', function(){ go(idx); start(); }); })(k); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var x0 = null;
    track.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; stop(); }, {passive:true});
    track.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 40){ dx < 0 ? next() : prev(); }
      x0 = null; start();
    }, {passive:true});

    root.addEventListener('shopify:block:select', function(e){
      for(var k=0;k<slides.length;k++){ if(slides[k] === e.target){ go(k); break; } }
      stop();
    });
    root.addEventListener('shopify:block:deselect', start);

    go(0);
    start();
  }
  function initAll(){ document.querySelectorAll('.putty-mv').forEach(initMv); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('.putty-mv');
    if(root){ delete root.dataset.mvReady; initMv(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
